export const streetNames = [
  "1st St NW",
  "2nd Ave SW",
  "3rd St SE",
  "4th Ave NE",
  "5th St SW",
  "6th Ave NW",
  "7th St SE",
  "8th Ave SW",
  "9th St NW",
  "10th Ave SE",
  "11th St SW",
  "12th Ave NW",
  "13th St SE",
  "14th Ave SW",
  "15th St NE",
  "16th Ave SW",
  "17th St NW",
  "18th Ave SE",
  "19th St SW",
  "20th Ave NW",
  "Maple St",
  "Jasper Ave",
  "Prairie Rd",
  "Douglas St",
  "Heritage Dr",
  "Summit Ave",
  "Willow St",
  "Kingston Rd",
  "Sage Ave",
  "Riverbend Dr",
  "Parkside St",
  "Cedar Ave",
  "Aspen Rd",
  "Spruce St",
  "Glenmore Ave",
  "Birch Rd",
  "Henderson St",
  "Sunset Ave",
  "Silverwood Dr",
  "Foxglove St",
  "Highland Ave",
  "Hawthorne Rd",
  "Pine St",
  "Chestnut Ave",
  "Lakeshore Dr",
  "McLeod St",
  "Redwood Ave",
  "Briar Rd",
  "Evergreen St",
  "Horizon Ave",
  "Riverside Dr",
  "Oak St",
  "St. Albert Ave",
  "Elk Rd",
  "Cameron St",
  "Bison Ave",
  "Hampton Dr",
  "Moss St",
  "Valleyview Ave",
  "Sherwood Rd",
  "Saddleback St",
  "Banff Ave",
  "Granite Rd",
  "Montrose St",
  "Brookside Ave",
  "Glenwood Dr",
  "Poplar St",
  "Sunridge Ave",
  "Larch Rd",
  "Dawson St",
  "Eagle Ave",
  "Victoria Dr",
  "Windsor St",
  "Springs Ave",
  "Crescent Rd",
  "Harvest St",
  "Canyon Ave",
  "Meadow Dr",
  "Fortune St",
  "Blossom Ave",
  "Patterson Rd",
  "Hillside St",
  "Strathcona Ave",
  "Baker Dr",
  "Sundance St",
  "Orchard Ave",
  "Fairmont Rd",
  "Abbey St",
  "Sunflower Ave",
  "McKenzie Dr",
  "Wheatland St",
  "Aurora Ave",
  "Horizon Rd",
  "Pioneer St",
  "Sable Ave",
  "Mountainview Dr",
  "Kingfisher St",
  "Lynx Ave",
  "Coyote Rd",
  "Forest St",
];

export const albertaPostalCodePrefixes = [
  "T0A",
  "T0B",
  "T0C",
  "T0E",
  "T0G",
  "T0H",
  "T0J",
  "T0K",
  "T0L",
  "T0M",
  "T0N",
  "T0P",
  "T0V",
  "T0W",
  "T0X",
  "T1A",
  "T1B",
  "T1C",
  "T1G",
  "T1H",
  "T1J",
  "T1K",
  "T1L",
  "T1M",
  "T1P",
  "T1R",
  "T1S",
  "T1V",
  "T1W",
  "T2A",
  "T2B",
  "T2C",
  "T2E",
  "T2G",
  "T2H",
  "T2J",
  "T2K",
  "T2L",
  "T2M",
  "T2N",
  "T2P",
  "T2R",
  "T2S",
  "T2T",
  "T2V",
  "T2W",
  "T2X",
  "T2Y",
  "T2Z",
  "T3A",
  "T3B",
  "T3C",
  "T3E",
  "T3G",
  "T3H",
  "T3J",
  "T3K",
  "T3L",
  "T3M",
  "T3N",
  "T3P",
  "T3R",
  "T3S",
  "T3Z",
  "T4A",
  "T4B",
  "T4C",
  "T4E",
  "T4G",
  "T4H",
  "T4J",
  "T4L",
  "T4M",
  "T4N",
  "T4P",
  "T4R",
  "T4S",
  "T5A",
  "T5B",
  "T5C",
  "T5E",
  "T5G",
  "T5H",
  "T5J",
  "T5K",
  "T5L",
  "T5M",
  "T5N",
  "T5P",
  "T5R",
  "T5S",
  "T5T",
  "T5V",
  "T5W",
  "T5X",
  "T5Y",
  "T5Z",
  "T6A",
  "T6B",
  "T6C",
  "T6E",
  "T6G",
  "T6H",
  "T6J",
  "T6K",
  "T6L",
  "T6M",
  "T6N",
  "T6P",
  "T6R",
  "T6S",
  "T6T",
  "T6V",
  "T6W",
  "T6X",
  "T7A",
  "T7E",
  "T7G",
  "T7N",
  "T7S",
  "T7V",
  "T7X",
  "T7Z",
  "T8A",
  "T8B",
  "T8C",
  "T8E",
  "T8G",
  "T8H",
  "T8L",
  "T8N",
  "T8R",
  "T8S",
  "T8V",
  "T8W",
  "T8X",
  "T8Z",
  "T9A",
  "T9C",
  "T9E",
  "T9G",
  "T9H",
  "T9J",
  "T9K",
  "T9M",
  "T9N",
  "T9S",
  "T9V",
  "T9W",
  "T9X",
  "T9Y",
  "T9Z",
];

export const provinces = ["AB"];

export const countries = ["CA"];

export const albertaCities = [
  "Calgary",
  "Edmonton",
  "Red Deer",
  "Lethbridge",
  "St. Albert",
  "Medicine Hat",
  "Grande Prairie",
  "Airdrie",
  "Spruce Grove",
  "Leduc",
  "Fort Saskatchewan",
  "Lloydminster",
  "Camrose",
  "Wetaskiwin",
  "Brooks",
  "Chestermere",
  "Sherwood Park",
  "Okotoks",
  "Cochrane",
  "Strathmore",
  "Canmore",
  "Banff",
  "Jasper",
  "Drumheller",
  "Fort McMurray",
];

export const genders = ["M", "F", "X"];

export const maleFirstNames = [
  "Liam",
  "Noah",
  "Oliver",
  "Theodore",
  "James",
  "Henry",
  "Mateo",
  "Elijah",
  "Lucas",
  "William",
  "Benjamin",
  "Levi",
  "Ezra",
  "Sebastian",
  "Jack",
  "Daniel",
  "Samuel",
  "Michael",
  "Ethan",
  "Asher",
  "John",
  "Hudson",
  "Luca",
  "Leo",
  "Elias",
  "Owen",
  "Alexander",
  "Dylan",
  "Santiago",
  "Julian",
  "David",
  "Joseph",
  "Matthew",
  "Luke",
  "Jackson",
  "Maverick",
  "Miles",
  "Wyatt",
  "Thomas",
  "Isaac",
  "Jacob",
  "Mason",
  "Gabriel",
  "Anthony",
  "Carter",
  "Logan",
  "Aiden",
  "Grayson",
  "Caleb",
  "Cooper",
  "Charles",
  "Roman",
  "Josiah",
  "Ezekiel",
  "Thiago",
  "Isaiah",
  "Joshua",
  "Wesley",
  "Jayden",
  "Bennett",
  "Christopher",
  "Nathan",
  "Angel",
  "Nolan",
  "Waylon",
  "Cameron",
  "Brooks",
  "Andrew",
  "Beau",
  "Weston",
  "Rowan",
  "Adrian",
  "Lincoln",
  "Enzo",
  "Ian",
  "Kai",
  "Christian",
  "Axel",
  "Aaron",
  "Theo",
  "Silas",
  "Walker",
  "Jonathan",
  "Leonardo",
  "Everett",
  "Micah",
  "Ryan",
  "August",
  "Gael",
  "Robert",
  "Jose",
  "Eli",
  "Jeremiah",
  "Luka",
  "Amir",
  "Jaxon",
  "Parker",
  "Colton",
  "Myles",
  "Adam",
  "Atlas",
  "Xavier",
];

export const femaleFirstNames = [
  "Olivia",
  "Emma",
  "Ava",
  "Sophia",
  "Isabella",
  "Mia",
  "Amelia",
  "Harper",
  "Evelyn",
  "Abigail",
  "Ella",
  "Elizabeth",
  "Sofia",
  "Avery",
  "Scarlett",
  "Grace",
  "Chloe",
  "Camila",
  "Penelope",
  "Riley",
  "Layla",
  "Lillian",
  "Nora",
  "Zoey",
  "Mila",
  "Aubrey",
  "Hannah",
  "Lily",
  "Addison",
  "Eleanor",
  "Natalie",
  "Luna",
  "Savannah",
  "Brooklyn",
  "Leah",
  "Zoe",
  "Stella",
  "Hazel",
  "Ellie",
  "Paisley",
  "Audrey",
  "Skylar",
  "Violet",
  "Claire",
  "Bella",
  "Aurora",
  "Lucy",
  "Anna",
  "Samantha",
  "Caroline",
  "Genesis",
  "Kennedy",
  "Sadie",
  "Allison",
  "Hailey",
  "Autumn",
  "Nevaeh",
  "Natalia",
  "Ruby",
  "Alice",
  "Serenity",
  "Eva",
  "Sarah",
  "Madelyn",
  "Cora",
  "Peyton",
  "Adeline",
  "Gianna",
  "Eliana",
  "Gabriella",
  "Naomi",
  "Lydia",
  "Ariana",
  "Aubree",
  "Willow",
  "Clara",
  "Vivian",
  "Reagan",
  "Elena",
  "Quinn",
  "Ivy",
  "Josephine",
  "Delilah",
  "Emery",
  "Sophie",
  "Piper",
  "Jade",
  "Brielle",
  "Madeline",
  "Julia",
  "Rylee",
  "Katherine",
  "Maria",
  "Reese",
  "Bailey",
  "Mary",
  "Morgan",
];

export const lastNames: string[] = [
  "Smith",
  "Johnson",
  "Williams",
  "Brown",
  "Jones",
  "Garcia",
  "Miller",
  "Davis",
  "Rodriguez",
  "Martinez",
  "Hernandez",
  "Lopez",
  "Gonzalez",
  "Wilson",
  "Anderson",
  "Thomas",
  "Taylor",
  "Moore",
  "Jackson",
  "Martin",
  "Lee",
  "Perez",
  "Thompson",
  "White",
  "Harris",
  "Sanchez",
  "Clark",
  "Ramirez",
  "Lewis",
  "Robinson",
  "Walker",
  "Young",
  "Allen",
  "King",
  "Wright",
  "Scott",
  "Torres",
  "Nguyen",
  "Hill",
  "Flores",
  "Green",
  "Adams",
  "Nelson",
  "Baker",
  "Hall",
  "Rivera",
  "Campbell",
  "Mitchell",
  "Carter",
  "Roberts",
  "Gomez",
  "Phillips",
  "Evans",
  "Turner",
  "Diaz",
  "Parker",
  "Cruz",
  "Edwards",
  "Collins",
  "Reyes",
  "Stewart",
  "Morris",
  "Morales",
  "Murphy",
  "Cook",
  "Rogers",
  "Gutierrez",
  "Ortiz",
  "Morgan",
  "Cooper",
  "Peterson",
  "Bailey",
  "Reed",
  "Kelly",
  "Howard",
  "Ramos",
  "Kim",
  "Cox",
  "Ward",
  "Richardson",
  "Watson",
  "Brooks",
  "Chavez",
  "Wood",
  "James",
  "Bennett",
  "Gray",
  "Mendoza",
  "Ruiz",
  "Hughes",
  "Price",
  "Alvarez",
  "Castillo",
  "Sanders",
  "Patel",
  "Myers",
  "Long",
  "Ross",
  "Foster",
  "Jimenez",
  "Powell",
  "Jenkins",
  "Perry",
  "Russell",
  "Sullivan",
  "Bell",
  "Coleman",
  "Butler",
  "Henderson",
  "Barnes",
  "Gonzales",
  "Fisher",
  "Vasquez",
  "Simmons",
  "Romero",
  "Jordan",
  "Patterson",
  "Alexander",
  "Hamilton",
  "Graham",
  "Reynolds",
  "Griffin",
  "Wallace",
  "Moreno",
  "West",
  "Cole",
  "Hayes",
  "Bryant",
  "Herrera",
  "Gibson",
  "Ellis",
  "Tran",
  "Medina",
  "Aguilar",
  "Stevens",
  "Murray",
  "Ford",
  "Castro",
  "Marshall",
  "Owens",
  "Harrison",
  "Fernandez",
  "Mcdonald",
  "Woods",
  "Washington",
  "Kennedy",
  "Wells",
  "Vargas",
  "Henry",
  "Chen",
  "Freeman",
  "Webb",
  "Tucker",
  "Guzman",
  "Burns",
  "Crawford",
  "Olson",
  "Simpson",
  "Porter",
  "Hunter",
  "Gordon",
  "Mendez",
  "Silva",
  "Shaw",
  "Snyder",
  "Mason",
  "Dixon",
  "Munoz",
  "Hunt",
  "Hicks",
  "Holmes",
  "Palmer",
  "Wagner",
  "Black",
  "Robertson",
  "Boyd",
  "Rose",
  "Stone",
  "Salazar",
  "Fox",
  "Warren",
  "Mills",
  "Meyer",
  "Rice",
  "Schmidt",
  "Garza",
  "Daniels",
  "Ferguson",
  "Nichols",
  "Stephens",
  "Soto",
  "Weaver",
  "Ryan",
  "Gardner",
  "Payne",
  "Grant",
  "Dunn",
  "Kelley",
  "Spencer",
  "Hawkins",
  "Arnold",
  "Pierce",
  "Vazquez",
  "Hansen",
  "Peters",
  "Santos",
  "Hart",
  "Bradley",
  "Knight",
  "Elliott",
  "Cunningham",
  "Matthews",
  "Craig",
  "Rodgers",
  "Reed",
  "Watkins",
  "Grant",
  "Wheeler",
  "Chapman",
  "Lawrence",
  "Harper",
  "George",
  "Greene",
  "Burke",
  "Larson",
  "Santiago",
  "Maldonado",
  "Morrison",
  "Franklin",
  "Carlson",
  "Austin",
  "Dominguez",
  "Carr",
  "Lawson",
  "Jacobs",
  "O'Brien",
  "Lynch",
  "Singh",
  "Vega",
  "Bishop",
  "Montgomery",
  "Oliver",
  "Jensen",
  "Harvey",
  "Williamson",
  "Gilbert",
  "Dean",
  "Sims",
  "Espinoza",
  "Howell",
  "Li",
  "Wong",
  "Reid",
  "Hanson",
  "Le",
  "Mccoy",
  "Garrett",
  "Burton",
  "Fuller",
  "Wang",
  "Weber",
  "Welch",
  "Rios",
  "Faulkner",
  "Chang",
  "Chavez",
  "Barker",
  "Cameron",
  "Cross",
  "Dennis",
  "Doyle",
  "Fleming",
  "Hopkins",
  "Hudson",
  "Jennings",
  "Klein",
  "Lucas",
  "Mann",
  "Moss",
  "Pena",
  "Phelps",
  "Pratt",
  "Quinn",
  "Ramsey",
  "Riley",
  "Saunders",
  "Schultz",
  "Shepherd",
  "Sloan",
  "Stokes",
  "Summers",
  "Tate",
  "Todd",
  "Tyler",
  "Vaughn",
  "Walton",
  "Wilkins",
  "Wyatt",
  "Yates",
  "Zimmerman",
  "Bates",
  "Beck",
  "Blevins",
  "Blair",
  "Boone",
  "Bowers",
  "Boyle",
  "Brady",
  "Brock",
  "Buck",
  "Calhoun",
  "Carroll",
  "Casey",
  "Chandler",
  "Clayton",
  "Cline",
  "Conner",
  "Conway",
  "Cooke",
  "Cowan",
  "Craft",
  "Dalton",
  "Daugherty",
  "Delgado",
  "Dickerson",
  "Dorsey",
  "Dotson",
  "Downs",
  "Dudley",
  "Duke",
  "Dunlap",
  "Eaton",
  "Ewing",
  "Farmer",
  "Finley",
  "Fitzgerald",
  "Foley",
  "Fry",
  "Galloway",
  "Gentry",
  "Glass",
  "Golden",
  "Goodwin",
  "Graves",
  "Griffith",
  "Gross",
  "Hahn",
  "Hardin",
  "Harmon",
  "Harrington",
  "Herring",
  "Hester",
  "Hodge",
  "Holloway",
  "Hooper",
  "Horn",
  "House",
  "Huber",
  "Huffman",
  "Hurst",
  "Irwin",
  "Jefferson",
  "Johnston",
  "Kaiser",
  "Kane",
  "Kaufman",
  "Keller",
  "Kerr",
  "Kidd",
  "Kirk",
  "Kirkland",
  "Kramer",
  "Lamb",
  "Larsen",
  "Lester",
  "Levine",
  "Logan",
  "Lowery",
  "Madden",
  "Maddox",
  "Manning",
  "Marks",
  "Mayer",
  "Mcbride",
  "Mccall",
  "Mccarthy",
  "Mccormick",
  "Mcdaniel",
  "Mcfarland",
  "Mcgee",
  "Mckee",
  "Mclaughlin",
  "Mclean",
  "Mcmillan",
  "Meadows",
  "Mejia",
  "Merritt",
  "Meyer",
  "Michaels",
  "Middleton",
  "Miles",
  "Mills",
  "Miranda",
  "Molina",
  "Montoya",
  "Moody",
  "Moon",
  "Morrow",
  "Moses",
  "Mosley",
  "Mullen",
  "Murillo",
  "Nash",
  "Nielsen",
  "Nixon",
  "Noble",
  "Nolan",
  "Norman",
  "Norris",
  "Ochoa",
  "Odom",
  "Olsen",
  "Oneal",
  "Osborn",
  "Osborne",
  "Owens",
  "Pace",
  "Pacheco",
  "Padilla",
  "Page",
  "Parrish",
  "Parsons",
  "Pate",
  "Patton",
  "Paul",
  "Payton",
  "Peck",
  "Pena",
  "Petersen",
  "Phelps",
  "Pickett",
  "Pittman",
  "Pollard",
  "Poole",
  "Pope",
  "Porter",
  "Potter",
  "Powers",
  "Preston",
  "Pruitt",
  "Pugh",
  "Quintana",
  "Rangel",
  "Rasmussen",
  "Ratliff",
  "Ray",
  "Reeves",
  "Reilly",
  "Reynolds",
  "Rich",
  "Riddle",
  "Riggs",
  "Rivas",
  "Roach",
  "Robles",
  "Roche",
  "Rojas",
  "Rollins",
  "Roman",
  "Rosales",
  "Rosario",
  "Roy",
  "Salas",
  "Salinas",
  "Sampson",
  "Sanford",
  "Santana",
  "Sargent",
  "Saucedo",
  "Sawyer",
  "Schneider",
  "Sears",
  "Sellers",
  "Shaffer",
  "Shannon",
  "Sharp",
  "Shea",
  "Shelton",
  "Sherman",
  "Shields",
  "Short",
  "Singleton",
  "Slater",
  "Sloan",
  "Small",
  "Snider",
  "Snow",
  "Solomon",
  "Sosa",
  "Sparks",
  "Spears",
  "Spence",
  "Stanton",
  "Stark",
  "Steele",
  "Stephenson",
  "Stout",
  "Strickland",
  "Strong",
  "Stuart",
  "Sweeney",
  "Sweet",
  "Tanner",
  "Tate",
  "Terrell",
  "Thomason",
  "Thorne",
  "Tillman",
  "Trevino",
  "Trujillo",
  "Underwood",
  "Valdez",
  "Valencia",
  "Valentine",
  "Vance",
  "Vargas",
  "Vaughan",
  "Velasquez",
  "Villarreal",
  "Vincent",
  "Wade",
  "Wagner",
  "Walsh",
  "Walter",
  "Walters",
  "Ware",
  "Waters",
  "Watts",
  "Weaver",
  "Webster",
  "Weeks",
  "Weiss",
  "Weston",
  "Wheeler",
  "Whitaker",
  "Whitehead",
  "Whitney",
  "Wilcox",
  "Wilder",
  "Wilkerson",
  "Wilkins",
  "Willis",
  "Winters",
  "Wise",
  "Witt",
  "Wolf",
  "Wolfe",
  "Woodard",
  "Woodward",
  "Wooten",
  "Workman",
  "Wright",
  "Wyatt",
  "Yang",
  "Yoder",
  "York",
  "Yu",
  "Zamora",
  "Zavala",
  "Zhang",
];
